module.exports = __webpack_public_path__ + "media/src/img/payment/qr_kaspi_tenge_som_qr_modal-5159d9dce6b5223d9e5adcccdc31f110.png";